import { z } from "zod";

import { ApifyActionSchema } from "./Apify.schema";
import { CustomManifestActionsSchema } from "./CustomManifest.schema";
import { PipedreamActionSchema } from "./Pipedream.schema";

/**
 * AgentExternalTool.actions — outer union discriminated by tool.type column.
 *
 * Use type-specific schemas directly when tool.type is known:
 *   PIPEDREAM       → z.array(PipedreamActionSchema)  (V1Component[])
 *   APIFY           → z.array(ApifyActionSchema)       (single "run" action)
 *   CUSTOM_MANIFEST → CustomManifestActionsSchema      (ActionType[])
 *
 * The three formats are fundamentally different:
 * - PIPEDREAM stores V1Component[] (Pipedream SDK format with key/version/configurable_props)
 * - APIFY stores a single ActionType-compatible action (run endpoint)
 * - CUSTOM_MANIFEST stores ActionType[] (Nexus format with path/method/operationId)
 *
 * This fallback union is for general parsing only — prefer type-specific schemas.
 */
export const AnyExternalToolActionsSchema = z.union([
  z.array(PipedreamActionSchema),
  CustomManifestActionsSchema,
  z.array(ApifyActionSchema),
  z.array(z.unknown()) // safety fallback
]);

export type AnyExternalToolActions = z.infer<typeof AnyExternalToolActionsSchema>;
